







































import { defineComponent } from 'vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { useSearchQuery } from '../../composables/global_search/useSearchQuery';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';

export default defineComponent({
  name: 'GlobalSearchBar',
  components: { Icon },
  props: {
    placeholder: { type: String, default: '' },
  },
  emits: ['search'],
  setup(props, { emit }) {
    const { query, isClearable, setQuery, clearQuery } = useSearchQuery();
    const { isLoading, initializeSearch } = useSearchExecution();

    const handleSearch = () => {
      if (!query.value || isLoading.value) {
        return;
      }
      setQuery(query.value);
      initializeSearch();
      emit('search', query);
    };

    return { query, isLoading, isClearable, clearQuery, handleSearch, iconClassEnum };
  },
});
